import React, { useEffect, useState } from "react";
import { AlertTriangle, Ban } from "lucide-react";
import { api } from "@/lib/api";

// Sprint 6 — dati azienda che bloccano o alterano le stampe (regola unica lato server)
export default function CompletezzaStampeBanner({ companyId, refreshKey }) {
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get(`/stampe/azienda/${companyId}/completezza`).then((r) => setC(r.data)).catch(() => setC(null));
  }, [companyId, refreshKey]);
  if (!c || (!c.bloccanti.length && !c.avvisi.length)) return null;
  return (
    <div className="mb-4 space-y-2" data-testid="company-completezza-stampe">
      {c.bloccanti.length > 0 && (
        <div className="rounded-md border border-rose-300 bg-rose-50 p-3 text-[13px] text-rose-900" data-testid="company-completezza-bloccanti">
          <div className="flex items-center gap-1 font-medium"><Ban className="h-4 w-4" /> Stampe bloccate: dati azienda essenziali mancanti</div>
          <ul className="list-disc pl-5 mt-1">{c.bloccanti.map((m, i) => <li key={i} data-testid={`company-bloccante-${i}`}>{m}</li>)}</ul>
        </div>
      )}
      {c.avvisi.length > 0 && (
        <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-[13px] text-amber-900" data-testid="company-completezza-avvisi">
          <div className="flex items-center gap-1 font-medium"><AlertTriangle className="h-4 w-4" /> Dati azienda da completare per le stampe</div>
          <ul className="list-disc pl-5 mt-1">{c.avvisi.map((m, i) => <li key={i} data-testid={`company-avviso-${i}`}>{m}</li>)}</ul>
        </div>
      )}
    </div>
  );
}
